import { Action } from '@/_core/fluxstore/types';
import { AccountState } from '../types';
import { useAccountStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { CancelPendingEmailChangeRequestCommand } from '@/api/account/commands';

const { registerMiddleware, registerReducer } = useAccountStore();

export class CancelPendingEmailChangeRequest extends Action<AccountState> {
    public static ACTION_TYPE = 'CancelPendingEmailChangeRequest';
    public constructor() {
        super(CancelPendingEmailChangeRequest.ACTION_TYPE);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const middleware = async (state: AccountState, action: CancelPendingEmailChangeRequest): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new CancelPendingEmailChangeRequestCommand(),
    });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const reducer = (state: AccountState, action: CancelPendingEmailChangeRequest): void => {
    state.hasPendingEmailAddressChange = false;
};

//@ts-ignore
registerMiddleware(CancelPendingEmailChangeRequest.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(CancelPendingEmailChangeRequest.ACTION_TYPE, reducer);
